<template>
    <div v-if="canShow('中医体质辨识（政府版）') && info && info.tizhi_text_array">
        <div class="tips"></div>
        <div class="sick-box">
            <div class="risk">中医体质辨识</div>
        </div>
        <div class="assessment" v-if=" isStep19 && info.tizhi_text_array && info.tizhi_text_array.length > 0 && info.tizhi_text_array[0]">
            <div class="new-title">您当前的中医体质<span v-if="info.tizhi_content.is_qingxiang">倾向是</span></div>
            <div class="sick-list flex flex-w">
                <div v-for="(item, index) in info.tizhi_text_array" :key="'main19-' + index" class="new-sick tiz-sick">
                    {{ formatTizhi(item) }}
                </div>
            </div>
        </div>
        <div class="assessment" v-if=" hasQingxiang && !info.tizhi_content.is_qingxiang">
            <div class="new-title">您当前的倾向体质</div>
            <div class="sick-list flex flex-w">
                <div v-for="(item, index) in info.tizhi_qingxiang_text_array" :key="'qx-' + index" class="new-sick tiz-sick">
                    {{ formatTizhi(item) }}
                </div>
            </div>
        </div>
        <div class="assessment" v-if=" !isStep19 && hasMain">
            <div class="new-title">您当前的中医体质<span v-if="info.tizhi_content.is_qingxiang">倾向是</span></div>
            <div class="sick-list flex flex-w">
                <div v-for="(item, index) in info.tizhi_content.physique" :key="'phy-' + index" class="new-sick tiz-sick">
                    {{ getPhysiqueName(item) }}<span v-if="isStep20">({{ index == 0 ? '主' : '兼' }})</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import {
    moduleMixin,
    isFlowStep19,
    isFlowStep20,
    hasQingxiangTizhi,
    hasMainPhysique,
    formatTizhiName,
    getPhysiqueName
} from '../helpers';

export default {
    name: 'ReportPhysique',
    mixins: [moduleMixin],
    computed: {
        ...mapState('report', ['info']),
        isStep19() { return isFlowStep19(this.info); },
        isStep20() { return isFlowStep20(this.info); },
        hasQingxiang() { return hasQingxiangTizhi(this.info); },
        hasMain() { return hasMainPhysique(this.info); }
    },
    methods: {
        getPhysiqueName,
        formatTizhi(name) { return formatTizhiName(name); }
    }
};
</script>
<style lang="scss" scoped>
@import './Physique.scss';
</style>
